import api from "../../services/api";
import { toast } from "react-toastify";

export async function listUsers(props) {
  const { config, query } = props;

  try {
    const { data: _users } = await api.get(`users?${query}`, config);

    const _users_return = _users?.map(__user => ({
      value: __user?.id,
      label: __user?.username,
    }));

    return _users_return;
  } catch (__error) {
    console.log("__error", __error);
    toast.error("Problemas ao tentar carregar a lista de usuários.");
  }
}
